<template>
  <section class="page about container">
    <div class="about__title" :class="{'not-loaded': notLoaded}">
      <AppTitle title="lof" size="big"/>
      <p class="about__scroll vertical-text">scroll</p>
    </div>

    <div v-if="content" class="about__presentation">
      <div class="about__left">
        <AppSplitLinesElem ref="splitDescription">
          <h2 class="about__presentation__baseline" v-html="content.acf.baseline" ref="splitElem"></h2>
        </AppSplitLinesElem>
      </div>
      <div class="about__right">
        <template v-for="(item, index) in content.acf.first_paragraphs">
          <p
          :key="index"
          v-html="item.paragraph"
          :class="{'about__paragraph--little': item.paragraph_type === 'small', 'about__paragraph': item.paragraph_type === 'large'}"></p>
        </template>
      </div>
    </div>

    <div v-if="content" class="about__presentation">
      <div class="about__left" v-if="!isMobile">
        <p 
          v-html="content.acf.vertical_baseline"
          class="about__presentation__vertical-baseline vertical-text">
        </p>
      </div>
      <div class="about__right">
        <template v-for="(item, index) in content.acf.second_paragraphs">
          <p
          :key="index"
          v-html="item.paragraph"
          :class="{'about__paragraph--little': item.paragraph_type === 'small', 'about__paragraph': item.paragraph_type === 'large'}"></p>
        </template>
      </div>
    </div>

  </section>
</template>

<script>
  import Page from '@/mixins/Page'

  import AppTitle from '@/components/AppTitle.vue'
  import AppSplitLinesElem from '@/components/AppSplitLinesElem.vue'

  export default {
    name: 'About',

    mixins: [
        Page
    ],

    components: {
      AppTitle,
      AppSplitLinesElem
    },

    data() {
      return {

      }
    },

    created()
    {
      const endpoint = '/wp-json/acf/v3/pages/32'
      this.loadDatas(endpoint, (res) => {

        this.content = res
        this.onLoadedDatas()

        this.$nextTick(() => {
            this.$refs.splitDescription.initSplitLines(this.$refs.splitElem)
        })
      })
    }
  }
</script>

<style lang="stylus">
  .about__title
    position relative
    // padding-top 200px
    margin-bottom 120px
    interpolate('margin-bottom', 768px, 2560px, 80px, 240px);
    // transform translateY(2vh)

    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

    @media(max-width 768px)
    // padding-top 20px
      margin-bottom 50px
      // transform translateY(0)

  .about__scroll
    position absolute
    top 58%
    right 0
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

    @media(max-width: 768px)
      display none

  .about__presentation
    width 100%
    display flex
    flex-wrap nowrap

    @media(max-width 768px)
      flex-direction column
    
    &:last-child
      .about__right>p:last-child
        margin-bottom 0


  .about__presentation__baseline
    line-height 1
    text-transform uppercase
    color $grey-light
    interpolate('font-size', 1600px, 2560px, 110px, 140px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 56px, 110px);

    @media(max-width 768px)
      font-size 32px

  .about__left
    width calc(100% / 18 * 8)
    padding-left calc(100% / 36)
    padding-right calc(100% / 36 * 2)

    @media(max-width 768px)
      width 100%
      padding 0
      margin-bottom 40px
  
  .about__right
    width calc(100% / 18 * 10)

    @media(max-width 768px)
      width 100%

  .about__presentation__vertical-baseline
    margin-top 100px
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 15px, 25px);

    @media(max-width 768px)
      display none

  .about__paragraph, .about__paragraph--little
    text-transform uppercase
    margin-bottom 90px
    interpolate('margin-bottom', 768px, 2560px, 75px, 150px);

    @media(max-width 768px)
      margin-bottom 60px

  .about__paragraph
    line-height 1
    interpolate('font-size', 1600px, 2560px, 60px, 84px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 30px, 60px);

    @media(max-width 768px)
      font-size 32px

  .about__paragraph--little
    width calc(100% / 10 * 6)
    // font-size 18px
    line-height 1.5
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 15px, 25px);

    @media(max-width 768px)
      width 100%

</style>